import DeepSeekLogo from '../logos/DeepSeekLogo'
import QwenLogo from '../logos/QwenLogo'
import NvidiaLogo from '../logos/NvidiaLogo'
import GoogleLogo from '../logos/GoogleLogo'
import MistralLogo from '../logos/MistralLogo'
import GlmLogo from '../logos/GlmLogo'
import KimiLogo from '../logos/KimiLogo'
import MiniMaxLogo from '../logos/MiniMaxLogo'
import XiaomiLogo from '../logos/XiaomiLogo'
import HiDreamLogo from '../logos/HiDreamLogo'
import LtxLogo from '../logos/LtxLogo'
import HunyuanLogo from '../logos/HunyuanLogo'
import BlackForestLogo from '../logos/BlackForestLogo'
import IdeogramLogo from '../logos/IdeogramLogo'
import KandinskyLogo from '../logos/KandinskyLogo'
import ThinkingMachinesLogo from '../logos/ThinkingMachinesLogo'

// Maps each maker to one of our existing verified logo components. Makers we
// don't have an SVG for (image/video labs, smaller labs) fall back to a
// tinted monogram badge rather than guessing at a logo.
const LOGO_BY_MAKER = {
  Moonshot: KimiLogo,
  'Z.ai': GlmLogo,
  DeepSeek: DeepSeekLogo,
  Alibaba: QwenLogo,
  NVIDIA: NvidiaLogo,
  Google: GoogleLogo,
  Mistral: MistralLogo,
  MiniMax: MiniMaxLogo,
  Xiaomi: XiaomiLogo,
  HiDream: HiDreamLogo,
  LTX: LtxLogo,
  Tencent: HunyuanLogo,
  'Black Forest': BlackForestLogo,
  Ideogram: IdeogramLogo,
  Kandinsky: KandinskyLogo,
  'Thinking Machines': ThinkingMachinesLogo,
}

// Black Forest's mark is a white glyph on a transparent background — it needs
// a dark badge behind it instead of the usual white one, or it disappears.
const DARK_BADGE_MAKERS = new Set(['Black Forest'])

const MONOGRAM_TINTS = {
  Genmo: '#14B8A6',
  Meta: '#0668E1',
}

export default function ModelLogo({ maker }) {
  const Logo = LOGO_BY_MAKER[maker]
  if (Logo) {
    const dark = DARK_BADGE_MAKERS.has(maker)
    return (
      <span
        className={`flex h-[26px] w-[26px] flex-none items-center justify-center overflow-hidden rounded-[7px] border p-[3px] [&>img]:h-full [&>img]:w-full [&>img]:object-contain [&>svg]:h-full [&>svg]:w-full ${
          dark ? 'border-[#0A0A0A] bg-[#0A0A0A]' : 'border-[var(--line)] bg-white'
        }`}
      >
        <Logo />
      </span>
    )
  }
  const tint = MONOGRAM_TINTS[maker] || '#8A97A6'
  return (
    <span
      className="flex h-[26px] w-[26px] flex-none items-center justify-center rounded-[7px] border font-mono text-[13px] font-bold"
      style={{ color: tint, borderColor: tint }}
    >
      {maker[0]}
    </span>
  )
}
